import {
  Instance_default
} from "./chunk-34IMAE2F.js";
import {
  BaseRoute_default
} from "./chunk-TY443UAN.js";

// src/Pim/PimLanguage/PimLanguageRoute.ts
var PimLanguageRoute = class extends BaseRoute_default {
  constructor() {
    super(...arguments);
    this.option = "reditem-item_pim_language";
    this.getList = (filters = {}) => {
      return Instance_default.get(
        this.createRequestURL({
          option: this.option,
          ...filters
        })
      );
    };
  }
};
var PimLanguageRoute_default = PimLanguageRoute;

export {
  PimLanguageRoute_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
